// @ts-nocheck
export const zh = {
  nav: {
    dashboard: '仪表盘',
    projects: '项目',
    knowledgeBase: 'Agent 训练',
    conversations: '对话',
    agentWorkspace: '客服工作台',
    analytics: '分析',
    settings: '设置',
  },
  common: {
    send: '发送',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    search: '搜索',
    loading: '加载中...',
    export: '导出',
    copy: '复制',
    view: '查看',
    viewAll: '查看全部',
    create: '创建',
    edit: '编辑',
    close: '关闭',
    add: '添加',
    or: '或',
  },
  auth: {
    welcomeBack: '欢迎回来',
    signInSubtitle: '登录管理您的AI客服系统',
    continueWithGoogle: '使用 Google 登录',
    signInWithGoogle: '使用 Google 登录',
    agreeToTerms: '登录即表示您同意我们的',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    and: '和',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    companyName: '公司名称',
    signIn: '登录',
    signUp: '注册',
    forgotPassword: '忘记密码？',
    noAccount: '还没有账号？',
    hasAccount: '已有账号？',
    resetPassword: '重置密码',
    resetPasswordDesc: '输入您的邮箱，我们将发送密码重置链接。',
    resetEmailSent: '密码重置邮件已发送，请查看收件箱。',
    sendResetEmail: '发送重置邮件',
    backToLogin: '返回登录',
    errorUserNotFound: '该邮箱未注册',
    errorWrongPassword: '密码错误',
    errorEmailInUse: '该邮箱已注册',
    errorWeakPassword: '密码强度不够（至少6位）',
    errorInvalidEmail: '邮箱格式不正确',
    errorTooManyRequests: '尝试次数过多，请稍后再试',
    errorPasswordMismatch: '两次密码不一致',
    errorGeneric: '操作失败，请重试',
  },
  dashboard: {
    title: '仪表盘',
    subtitle: '欢迎回来！以下是您今天的客户服务情况。',
    todayConversations: '今日对话',
    activeUsers: '活跃用户',
    resolutionRate: '解决率',
    avgResponseTime: '平均响应时间',
    vsLastWeek: '较上周',
    monthlyConversations: '月度对话',
    plan: '套餐',
    used: '已使用',
    approachingLimit: '即将达到月度限制。请考虑升级以保证服务不中断。',
    limitReached: '月度对话限额已用完。',
    upgradePlan: '升级套餐',
    recentConversations: '最近对话',
    topTopics: '热门话题',
    lastMessage: '最后消息',
    resolved: '已解决',
    minAgo: '分钟前',
  },
  conversations: {
    title: '对话',
    subtitle: '查看和管理客户对话。',
    all: '全部',
    active: '进行中',
    ended: '已结束',
    escalated: '已转人工',
    noConversationsFound: '没有找到对话',
    session: '会话',
    messages: '条消息',
    selectConversation: '选择一个对话查看详情',
    sources: '来源',
    msgs: '条',
  },
  knowledgeBase: {
    title: '知识库',
    subtitle: '管理文档和问答对以提升AI回答质量。',
    uploadDocument: '上传文档',
    addQA: '添加问答',
    searchPlaceholder: '搜索文档和问答...',
    documents: '文档',
    qa: '问答',
    noDocumentsFound: '未找到文档',
    noQAFound: '未找到问答对',
    adjustSearch: '请尝试调整搜索条件。',
    getStartedDocument: '上传文档开始使用。',
    getStartedQA: '创建问答对开始使用。',
    created: '创建于',
    updated: '更新于',
    uploadDocumentTitle: '上传文档',
    uploadDescription: '上传 PDF、Word 或文本文件来训练您的AI助手。',
    clickToUpload: '点击上传或拖放文件',
    fileFormats: 'PDF、DOC、DOCX、TXT，最大10MB',
    addQAPair: '添加问答对',
    question: '问题',
    answer: '回答',
    questionPlaceholder: '您的退货政策是什么？',
    answerPlaceholder: '我们的退货政策允许在30天内退货...',
  },
  settings: {
    title: '设置',
    subtitle: '配置您的组件、管理API密钥和控制团队访问。',
    widgetConfiguration: '组件配置',
    apiSettings: 'API设置',
    escalation: '转接设置',
    billingUsage: '计费与用量',
    teamManagement: '团队管理',
    widgetAppearance: '组件外观',
    theme: '主题',
    light: '浅色',
    dark: '深色',
    auto: '自动',
    primaryColor: '主题色',
    position: '位置',
    bottomRight: '右下角',
    bottomLeft: '左下角',
    topRight: '右上角',
    topLeft: '左上角',
    welcomeMessage: '欢迎消息',
    messagePlaceholder: '消息占位符',
    features: '功能',
    showAvatar: '显示头像',
    showTimestamps: '显示时间戳',
    allowFileUploads: '允许文件上传',
    widgetIntegration: '组件集成',
    widgetIntegrationDesc: '将以下代码复制粘贴到您网站的 <head> 部分以添加聊天组件。',
    asyncLoad: '组件将异步加载，不影响页面加载性能。',
    apiConfiguration: 'API配置',
    primaryApiKey: '主API密钥',
    apiKeySecret: '请妥善保管您的API密钥。它用于验证对ClawCustomer API的请求。',
    webhookUrl: 'Webhook URL（可选）',
    webhookDesc: '接收新对话和消息的实时通知。',
    rateLimit: '速率限制（每分钟请求数）',
    escalationConfiguration: '转接配置',
    escalationDesc: '配置当AI无法解决问题时自动转接到人工客服。',
    enableEscalation: '启用转接到人工客服',
    telegramBotToken: 'Telegram Bot Token',
    telegramChatId: 'Telegram Chat ID',
    triggerKeywords: '触发关键词',
    triggerKeywordsDesc: '逗号分隔的关键词。AI回复包含这些关键词时将触发转接。',
    handoffMessage: '转接消息',
    handoffMessageDesc: '触发转接时向用户显示的消息。',
    sendTestMessage: '发送测试消息',
    sending: '发送中...',
    testSuccess: '测试消息发送成功！',
    testFailed: '发送测试消息失败。请检查配置。',
    billingTitle: '计费与用量',
    billingDesc: '管理您的订阅、查看用量并更新计费信息。',
    teamMembers: '团队成员',
    teamDesc: '管理谁可以访问您的ClawCustomer账户。',
    inviteMember: '邀请成员',
    emailAddress: '邮箱地址',
    role: '角色',
    status: '状态',
    joined: '加入时间',
    member: '成员',
    admin: '管理员',
    inviteTeamMember: '邀请团队成员',
    sendInvitation: '发送邀请',
    saveSettings: '保存设置',
    saving: '保存中...',
  },
  projects: {
    title: '项目',
    subtitle: '管理不同网站和应用的聊天组件和集成。',
    newProject: '新建项目',
    status: '状态',
    conversations: '对话数',
    apiKey: 'API密钥',
    createNewProject: '创建新项目',
    projectName: '项目名称',
    domain: '域名',
    createProject: '创建项目',
  },
  analytics: {
    title: '分析',
    subtitle: '跟踪客户服务表现并发现改进机会。',
    last7Days: '最近7天',
    last30Days: '最近30天',
    last90Days: '最近90天',
    totalConversations: '总对话数',
    resolutionRate: '解决率',
    avgResponseTime: '平均响应时间',
    satisfactionScore: '满意度评分',
    conversationTrends: '对话趋势',
    total: '总计',
    resolved: '已解决',
    mostAskedQuestions: '最常问的问题',
    responseTimeByHour: '按时段响应时间',
    averageSeconds: '平均秒数',
    customerSatisfaction: '客户满意度',
    outOf5: '满分5.0',
  },
  layout: {
    signOut: '退出登录',
    openSidebar: '打开侧边栏',
    closeSidebar: '关闭侧边栏',
    notifications: '查看通知',
    switchToEnglish: 'English',
    switchToChinese: '中文',
  },
  toast: {
    signInSuccess: '登录成功！',
    signInFailed: '登录失败',
    signUpSuccess: '账号创建成功！',
    signUpFailed: '创建账号失败',
    googleSignInSuccess: 'Google 登录成功！',
    completeSetup: '请完善您的信息',
    googleSignInFailed: 'Google 登录失败',
    resetEmailSent: '密码重置邮件已发送',
    resetEmailFailed: '发送重置邮件失败',
    signOutSuccess: '已退出登录',
    signOutFailed: '退出失败',
    profileLoadFailed: '加载用户信息失败',
  },
  billing: {
    unableToLoad: '无法加载订阅信息',
    unableToLoadDesc: '无法获取您的订阅信息。',
    tryAgain: '重试',
    currentPlan: '当前套餐',
    conversationsUsed: '已用对话数',
    usageLimitExceeded: '用量已超限',
    approachingLimit: '即将达到用量限制',
    nextBilling: '下次扣费：',
    billingPeriod: '计费周期：',
    cancelNotice: '您的订阅将在当前计费周期结束时取消。',
    upgradeToStarter: '升级到 Starter',
    upgradeToPro: '升级到 Pro',
    upgradeToBusiness: '升级到 Business',
    manageSubscription: '管理订阅',
    processing: '处理中...',
    planComparison: '套餐对比',
    perMonth: '/月',
    conversations: '对话数',
    projects: '项目数',
    statusActive: '有效',
    statusTrial: '试用',
    statusCanceled: '已取消',
    statusPastDue: '逾期',
    statusIncomplete: '未完成',
    free: '免费版',
    starter: 'Starter',
    pro: 'Pro',
    business: 'Business',
    enterprise: 'Enterprise',
  },
  placeholders: {
    welcomeMessage: '你好！有什么可以帮你的吗？',
    typeMessage: '输入您的消息...',
    handoffMessage: '您的对话正在转接到人工客服，请稍候。',
    telegramHelp: '从 Telegram 的 @BotFather 获取。',
    triggerKeywords: '人工客服, 转人工, 投诉, 经理',
    webhookUrl: 'https://your-site.com/webhook',
    inviteEmail: 'colleague@example.com',
    projectName: '我的网站',
    projectDomain: 'mywebsite.com',
    typeResponse: '输入回复...',
    pressEnterToSend: 'Enter 发送，Shift+Enter 换行',
  },
  agent: {
    workspace: '客服工作台',
    disconnected: '连接断开',
    currentChats: '当前接待',
    online: '在线',
    away: '离开',
    offline: '离线',
    pending: '待接入',
    noQueuedSessions: '暂无排队会话',
    newSession: '新会话',
    unknownProject: '未知项目',
    myChats: '我的对话',
    noActiveChats: '暂无进行中的对话',
    chatting: '对话中',
    humanAgentConnected: '人工客服已接入',
    selectSession: '选择一个会话开始接待',
    selectSessionHint: '左侧列表点击会话即可接入',
    humanMode: '人工接待中',
    queuedMode: '排队中',
    escalationReason: '转人工原因',
    backToAI: '切回AI',
    addNote: '添加备注',
    closeSession: '结束会话',
    noMessages: '暂无消息记录',
    inputPlaceholder: '输入消息... (Enter 发送, Shift+Enter 换行)',
    addNotePrompt: '添加备注：',
    session: '会话',
    userChat: '用户对话',
    agent: '客服',
  },
}
